<template>
  <div class="label-content"><slot /></div>
</template>

<script>
export default {
  name: "AppLabelContent"
}
</script>
